import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import {POItemBalance, SearchPODialogListProps, tPurchaseOrderModel,tPurchaseOrderModelwithWHName} from '../models/tPurchaseOrderModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';


@Injectable({
    providedIn: 'root'
})

export class tPurchaseOrderService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tPurchaseOrder';

    UrlProps = this.baseurl + this.pathName;


    getAllData() {
        return this.http.get<tPurchaseOrderModel[]>(this.baseurl + this.pathName);
    }

    getVendorData(vendor:string) {
        return this.http.get<SearchPODialogListProps[]>(this.baseurl + this.pathName+'/getVendor/'+vendor);
    }

    savePO(data: any) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted/SavePO/', data);
    }
    getPoNumber(poNumber:string,barCode:string){
        return this.http.get<SearchPODialogListProps[]>(this.baseurl + this.pathName+'/getPoNumber/'+poNumber+'/'+barCode);
    }
    
    getPOGroupedHeadSearch(shopID: string, data: any) {
        return this.http.post<tPurchaseOrderModelwithWHName[]>(this.baseurl + this.pathName + '/GetPOGroupedHeadSearch/' + shopID, data);
    }

    deleteData(data: tPurchaseOrderModel) {
        return this.http.delete(this.baseurl + this.pathName + '/' + NavigationComponent.selectedShopID.toString() + '/' + data.poNumber);
    }

    getSavedPO(shopID: string, poNumber: string) {
        return this.http.get<tPurchaseOrderModel[]>(this.baseurl + this.pathName + '/GetSavedPO/' + shopID + '/' + poNumber);
    }

    getPOItemsBalance(vendorCode:string){
        return this.http.get<POItemBalance[]>(`${this.UrlProps}/itemBalanceByVendor/${vendorCode}`); 
    }
    getPOItemsBalancePo(poNumber:string){
        return this.http.get<POItemBalance[]>(`${this.UrlProps}/itemBalanceByPO/${poNumber}`); 
    }
}
